var map = {
	"./AgriculturalLandReserve.jsx": 7466,
	"./AirConditionedBuildings.jsx": 64557,
	"./AquiferSusceptibilityBedrock.jsx": 60144,
	"./AquiferSusceptibilitySediment.jsx": 58145,
	"./Aquifers.jsx": 72692,
	"./BCTransitRoutes.jsx": 9788,
	"./BigTrees.jsx": 25193,
	"./CRDAffordableHousing.jsx": 65550,
	"./CRDBikeMap.jsx": 72534,
	"./CRD_Parks.jsx": 94187,
	"./CarbonSequestration.jsx": 57870,
	"./CentennialSquareTree.jsx": 11932,
	"./CherryTrees.jsx": 95739,
	"./CircularEconomyBusinesses.jsx": 51,
	"./CoastalFloodInundationScenarios.jsx": 81789,
	"./CommunityMaps.jsx": 83234,
	"./CommunityMaps_BTH.jsx": 52293,
	"./CulturalFoods.jsx": 4313,
	"./CulturalFoodsOGM.jsx": 97746,
	"./CultureCompassOGM.jsx": 46749,
	"./DrinkingFountains.jsx": 95333,
	"./ENBS.jsx": 99489,
	"./EVChargingStations.jsx": 96765,
	"./Eelgrass.jsx": 32114,
	"./FarmFresh.jsx": 33716,
	"./FarmToFork.jsx": 58661,
	"./FireStations.jsx": 71973,
	"./FoodSecurity.jsx": 41381,
	"./ForageFish.jsx": 89802,
	"./GarryOakAreas.jsx": 8034,
	"./GarryOak_NativeEcosystems.jsx": 29177,
	"./GarryOak_OldNewExtent.jsx": 41296,
	"./GreenBlueBelt.jsx": 57874,
	"./GreenhouseGasOnRoad2020.jsx": 3047,
	"./GreenhouseGasOnRoad2022.jsx": 38241,
	"./GreenhouseGasStationary2020.jsx": 5520,
	"./GreenhouseGasStationary2022.jsx": 78654,
	"./GreenspaceForAll-RestrictedGreenspace.jsx": 15794,
	"./GreenspaceForAll-UnderservedCommunity.jsx": 83976,
	"./HardShorelines.jsx": 22465,
	"./HartlandLandfill.jsx": 16656,
	"./HeatDomes.jsx": 29478,
	"./HeatExposureAirTemp.jsx": 55685,
	"./HeatExposureLandSurfaceTemp.jsx": 81109,
	"./Impervious2019.jsx": 18557,
	"./ImportantBirdAreas.jsx": 29677,
	"./KelpBeds.jsx": 64450,
	"./LittleFreeLibraries.jsx": 43571,
	"./LocalClimateInitiatives.jsx": 71895,
	"./MajorTransportationHubs.jsx": 13781,
	"./MaltbyLakeBirdsong.jsx": 6964,
	"./MetchosinWestshoreFarmToFork.jsx": 15345,
	"./MunicipalHousingTargets.jsx": 4117,
	"./Municipalities.jsx": 48226,
	"./NativeLandDigitalLanguages.jsx": 36029,
	"./NativeLandDigitalTerritories.jsx": 74034,
	"./NativeLandDigitalTreaties.jsx": 6263,
	"./NatureHood_Animals.jsx": 87355,
	"./NatureHood_FirstNationsReserves.jsx": 61311,
	"./NatureHood_LearningCentres.jsx": 74217,
	"./NatureHood_Locations.jsx": 7656,
	"./NatureHood_MBS.jsx": 72448,
	"./NatureHood_PlaceNames.jsx": 52909,
	"./NatureHood_PlaceNamesEnglish.jsx": 72245,
	"./NatureInspiredPlaygrounds.jsx": 13639,
	"./Pollinators.jsx": 25861,
	"./ProposedHousingDevelopments.jsx": 86149,
	"./PumpoutStations.jsx": 66947,
	"./RainGardens.jsx": 2808,
	"./RecyclingDepots.jsx": 5499,
	"./RestorationSites.jsx": 84086,
	"./SensitiveEcosystems.jsx": 10383,
	"./ShellfishPO.jsx": 1503,
	"./ShorelineSensitivity.jsx": 44892,
	"./SingleUseItemBylaws.jsx": 98292,
	"./SpeciesAtRisk.jsx": 14272,
	"./StewardshipGroups.jsx": 68650,
	"./TreeBylaws.jsx": 85270,
	"./TreeCoverage2005.jsx": 53539,
	"./TreeCoverage2019.jsx": 84132,
	"./TreeEquity.jsx": 4163,
	"./VictoriaShelters.jsx": 88103,
	"./WatershedRunoffAbsorption.jsx": 16522,
	"./Watersheds.jsx": 29724
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66312;